import { useQuery } from '@tanstack/react-query'
import { request } from '@/utils/axiosUtil'

export default function useCategoriesService() {
  const getCategoriesData = async () => {
    const apiUrl = '/categories'
    const res = await request({ url: apiUrl })
    if (res?.status == 200) {
      const categories = res?.data?.data
      categories.sort((a, b) => a.subCategories?.length - b.subCategories?.length)
      const updatedData = [
        categories.find((category) => category.category === 'Popular & Trending'),
        ...categories.filter((category) => category.category !== 'Popular & Trending'),
      ]
      return updatedData || []
    } else {
      return res?.response?.data
    }
  }
  return useQuery(['categoriesService'], () => getCategoriesData(), {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })
}